import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { requestSectionNav } from '@/lib/sectionNav';

interface SectionLinkProps {
  /** Id de la sección destino dentro del inicio (ej: "catalogo"). */
  section: string;
  className?: string;
  onClick?: () => void;
  children: ReactNode;
}

// Enlace reutilizable hacia una sección del inicio (catálogo, testimonios, ...).
//
// IMPORTANTE — por qué está así:
// Antes este enlace navegaba a una URL CON hash (`/#catalogo`) interceptando el
// clic a mano (preventDefault + navigate programático). Esa combinación hacía
// que la navegación se revirtiera al venir desde el checkout: "parpadeaba" el
// inicio pero el usuario se quedaba en la página de pago.
//
// La diferencia que delataba el problema era el botón "Inicio": un `<Link to="/">`
// normal, sin hash ni trucos, que SÍ funcionaba siempre.
//
// Por eso ahora este enlace usa EXACTAMENTE ese mismo camino:
// - `<Link to="/">` nativo (sin preventDefault, sin hash).
// - El destino de la sección viaja por el `state` de navegación.
// - ADEMÁS se guarda en sessionStorage (requestSectionNav) para que, si el
//   navegador recarga la página al navegar y el `state` se pierde, el gestor
//   global igual sepa a qué sección bajar.
// - El salto lo ejecuta el ScrollManager global, que es el ÚNICO dueño del scroll.
export default function SectionLink({ section, className, onClick, children }: SectionLinkProps) {
  return (
    <Link
      to="/"
      state={{ scrollTo: section }}
      onClick={() => {
        requestSectionNav(section);
        onClick?.();
      }}
      className={className}
    >
      {children}
    </Link>
  );
}